import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import Button from '../ui/Button';
import Modal from '../ui/Modal';
import { authService } from '../../services/api/auth';

interface LogoutButtonProps {
  className?: string;
  variant?: 'outline' | 'ghost' | 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  variant = 'ghost',
  size = 'md'
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const navigate = useNavigate();

  const confirmLogout = async () => {
    setIsLoading(true);
    
    try {
      await authService.logout();
      navigate('/', { replace: true });
    } catch (error) {
      navigate('/', { replace: true });
    } finally {
      setIsLoading(false);
      setIsConfirmOpen(false);
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsConfirmOpen(true)}
        loading={isLoading}
        variant={variant}
        size={size}
        className={`text-gray-600 hover:text-red-600 ${className}`}
      >
        <LogOut className="w-4 h-4 mr-2" />
        {isLoading ? 'Déconnexion...' : 'Déconnexion'}
      </Button>

      <Modal
        isOpen={isConfirmOpen}
        onClose={() => !isLoading && setIsConfirmOpen(false)}
        title="Confirmer la déconnexion"
        type="warning"
      >
        <div className="space-y-4">
          <p className="text-sm text-gray-700">
            Voulez-vous vraiment vous déconnecter de votre session ?
          </p>
          <div className="flex items-center justify-end space-x-3 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsConfirmOpen(false)}
              disabled={isLoading}
            >
              Annuler
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={confirmLogout}
              loading={isLoading}
              disabled={isLoading}
            >
              Se déconnecter
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogoutButton;
